"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AGHitsPerPage_styles_1 = __importDefault(require("./AGHitsPerPage.styles"));
var react_instantsearch_dom_1 = require("react-instantsearch-dom");
var HitsPerPage = function (_a) {
    var items = _a.items, refine = _a.refine;
    return (react_1.default.createElement(AGHitsPerPage_styles_1.default, null,
        react_1.default.createElement("p", { className: "text" },
            "Toon",
            items.map(function (item) { return (react_1.default.createElement("a", { href: "#", className: item.isRefined ? 'active' : '', onClick: function (event) {
                    event.preventDefault();
                    refine(item.value);
                }, key: item.value }, item.label)); }),
            "resultaten van\u00A0"),
        react_1.default.createElement(react_instantsearch_dom_1.Stats, { translations: {
                stats: function (nbHits) {
                    return "" + nbHits;
                },
            } })));
};
var AGHitsPerPage = react_instantsearch_dom_1.connectHitsPerPage(HitsPerPage);
exports.default = AGHitsPerPage;
